
export const PAYMENTS_API_URL = {
  getTariffs: () => `/v1/payment/price`,
  createTariff: () => `/v1/payment/yookassa/order-create`,
  getPayHistory: (id: string | null) => `v1/payment/yookassa/order_status/${id ?? ""}`,
  createTeamTariff: () => `/v1/notify/mail_buy_team_package`,
  applyPromoCode: () => `/v1/payment/promo/apply`
};
